import { Badge } from '@/components/ui/badge';
import { Wrench, Gauge } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SpecialtyBadgesProps {
  requiresAlignment?: boolean;
  requiresAdas?: boolean;
  className?: string;
}

export const SpecialtyBadges = ({ 
  requiresAlignment, 
  requiresAdas,
  className 
}: SpecialtyBadgesProps) => {
  if (!requiresAlignment && !requiresAdas) {
    return null;
  }

  return (
    <div className={cn("flex gap-1 flex-wrap", className)}>
      {requiresAlignment && (
        <Badge 
          variant="secondary" 
          className="text-xs flex items-center gap-1 bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/20"
          data-testid="specialty-badge-alignment"
        >
          <Gauge className="h-3 w-3" />
          Alignment
        </Badge>
      )}
      {requiresAdas && (
        <Badge 
          variant="secondary" 
          className="text-xs flex items-center gap-1 bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20"
          data-testid="specialty-badge-adas"
        >
          <Wrench className="h-3 w-3" />
          ADAS
        </Badge>
      )}
    </div>
  );
};
